import { Box } from "@mui/material";
import React from "react";
import Button from "../buttons/Buttons";
import styles from "./twoButtonFooterSection.module.scss";
import PropTypes from "prop-types";
const TwoButtonFooterSection = (props) => {
  return (
    <Box
      className={styles.twoButtonWrapper}
      data-testid="TwoButtonFooterSection"
    >
      {props.btnlist?.map(
        ({
          title,
          iconStyle,
          buttonType,
          attriType,
          withIcon,
          showCountSection,
          count,
          handleClick,
          isDisabled = false,
        }) => {
          return (
            <Button
              key={title}
              title={title}
              iconStyle={iconStyle}
              buttonType={buttonType}
              attriType={attriType}
              withIcon={withIcon}
              showCountSection={showCountSection}
              count={count}
              handleClick={handleClick}
              isDisabled={isDisabled}
            />
          );
        }
      )}
    </Box>
  );
};

export default TwoButtonFooterSection;
TwoButtonFooterSection.propTypes = {
  btnlist: PropTypes.any,
};
